export interface IBaseResponse {
    data: {
        success: boolean;
        message: string;
        results: any;
    }
}

export interface ITypedBaseResponse<T> {
    data: {
        success: boolean;
        message: string;
        results: T;
    }
}